module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-up-grey-787b2403d7064a25c30d62a9f64006cf.svg";